declare var Swal;
declare var grecaptcha;

namespace RT {
    export function recaptchaInclude(siteKey : string, insertBeforeElement: JQuery, validationRules: any, validationMessages: any)
    {
        let recaptchaName = "grecaptcha";
        let recaptchaValidationMessage = "Ben robot değilim doğrulamasını yapınız.";

        //Recaptcha ekleniyor
        if (!!(window[recaptchaName] == null && $('script#RecaptchaInclude').length === 0)) {
            var src = 'https://www.google.com/recaptcha/api.js';
            var lng = $('html').attr('lang') ?? '';
            src += '?hl=' + lng;
            $('<script/>').attr('id', 'RecaptchaInclude').attr('src', src).appendTo(document.body);
        }

        //Recaptcha ekleniyor
        let row = $('<div class="row"/>');
        let col_12 = $('<div class="col-12"/>');
        let formgroup = $('<div class="form-group"/>');
        let div = $('<div data-callback="rc" data-expired-callback="re"/>').addClass('g-recaptcha').attr('data-sitekey', siteKey);
        let i = $('<input id="' + recaptchaName + '" name="' + recaptchaName + '" type="text" style="opacity: 0; position: absolute; top: 0; left: 0; height: 1px; width: 1px;"/>');
        div.appendTo(formgroup);
        i.appendTo(formgroup);
        formgroup.appendTo(col_12);
        col_12.appendTo(row);
        row.insertBefore(insertBeforeElement);

        //Recaptcha doğrulaması validasyonu ekleniyor
        validationRules[recaptchaName] = { required: true, minlength: 255 };
        validationMessages[recaptchaName] = { required: recaptchaValidationMessage };

        //Recaptcha callback fonksiyonları
        window['rc'] = (t)=> $('#' + recaptchaName).val(t);
        window['re'] = ()=> $('#' + recaptchaName).val('');
    }
}
